<template>
  <div v-if="isVisible" class="cuw-appAndroidBanner">
    <img 
      src="https://cosmicup.me/wp-content/uploads/2025/07/Icon_app_cosmicup.png" 
      :alt="$t('appAndroidBanner.iconAlt')" 
      class="cuw-appAndroidBanner__icon"
    >

    <div class="cuw-appAndroidBanner__info">
      <div class="cuw-appAndroidBanner__title">{{ $t('appAndroidBanner.title') }}</div>
      <div class="cuw-appAndroidBanner__subtitle">{{ $t('appAndroidBanner.subtitle') }}</div>
    </div>
    
    <button 
      class="cuw-appAndroidBanner__button" 
      @click="redirectToPlayStore"
    >
      {{ $t('appAndroidBanner.get') }}
    </button>
    
    <div class="cuw-appAndroidBanner__close" @click="closeBanner">
      <img 
        src="https://cosmicup.me/wp-content/uploads/2025/09/close.svg" 
        class="cuw-appAndroidBanner__closeIcon"
        :alt="$t('appAndroidBanner.closeAlt')"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAndroidBanner',
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    this.checkVisibility()
  },
  methods: {
    checkVisibility() {
      // Check if banner should be visible based on the condition
      const isNotAndroidApp = !window.WTN?.isAndroidApp
      const isNotIosApp = !window.WTN?.isIosApp
      const isAndroidUserAgent = window.navigator.userAgent.toLowerCase().includes('android')
      
      this.isVisible = isNotAndroidApp && isNotIosApp && isAndroidUserAgent && false;
    },
    closeBanner() {
      this.isVisible = false
    },
    redirectToPlayStore() {
      window.open('https://play.google.com/store/apps/details?id=com.cosmicup.lumaup.com&referrer=utm_source%3DinternalTool%26utm_medium%3Dbanner', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700;800&display=swap');
.cuw-appAndroidBanner {
  display: grid;
  grid-template-columns: 65px 1fr 85px 25px;
  align-items: center;
  gap: 3px;
  font-family: 'Nunito', sans-serif;
  margin: 0;
  background: #191826;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-sizing: border-box;
  padding: 8px 5px;

  &__icon {
    width: 60px;
    border-radius: 15px;
  }

  &__info {
    color: white;
  }

  &__title {
    font-size: 14px;
    min-width: 0; /* senza questo la cella non si restringe */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__subtitle {
    font-size: 12px;
    opacity: 0.7;
  }

  &__button {
    border: none;
    outline: none;
    background: #A4C639;
    color: white;
    font-family: 'Nunito', sans-serif;
    border-radius: 50px;
    font-weight: 800;
    font-size: 14px;
    width: 70px;
    height: 30px;
    cursor: pointer;
    justify-self: center;

    &:hover {
      background: #95b530;
    }
  }

  &__close {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  &__closeIcon {
    width: 12px;
    margin-left: -5px;
  }
}
</style>
